<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Campaign creator -
            <button type="button" class="btn btn-primary" v-if="step > 0" @click="step--">Back</button>
            <button type="button" class="btn btn-primary" v-if="step > 0 && canNext" @click="step++">Next</button>
            <button type="button" class="btn btn-primary" v-if="step === 0" :disabled="!canNext"
                @click="validate1Step">Validate and next</button>
            <button type="button" class="btn btn-primary" v-if="step === 2" @click="save()">Save</button>
            <button class="btn btn-link" @click="$emit('close')">Cancel</button>
        </template>
        <div class="alert alert-danger" v-if="err">{{ err }}</div>
        <div class="alert alert-success" v-if="success">{{ success }}</div>
        <div class="row" v-if="step === 0">
            <div class="col-12">
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Campaign Template</label>
                        <div class="col-lg-8">
                            <multiselect v-model="selected_template" tag-placeholder=""
                                placeholder="Select a campaign template (optional)" label="name" track-by="_id"
                                :options="campaign_templates || []" :multiple="false" @select="onTemplateSelected">
                            </multiselect>
                            <small>Select a template to auto-populate form fields, or leave empty to fill
                                manually</small>
                        </div>
                        <div class="col-lg-2">
                            <button type="button" class="btn btn-secondary" v-if="selected_template"
                                @click="clearTemplate">Clear</button>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="col-6">
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-4">Campaign name</label>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" v-model="form_common.name">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-form-label col-lg-3">
                            Sender template
                        </label>
                        <div class="col-lg-8">
                            <multiselect v-model="form_common.name_template" tag-placeholder=""
                                placeholder="Search sender names template" label="name" track-by="name"
                                :options="name_templates || []" :multiple="false"></multiselect>
                        </div>
                    </div>

                    <div class="form-group row" v-if="false">
                        <label class="col-form-label col-lg-3">Choose mailer account</label>
                        <div class="col-lg-6">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.mailer_account" tag-placeholder=""
                                    placeholder="Search for a mailer account" label="name" track-by="_id"
                                    :options="mailer_account || []" :multiple="false"></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.mailer_account !== null">
                        <label class="col-form-label col-lg-3">Set limit for sending per domain</label>
                        <div class="col-lg-6">
                            <input type="number" class="form-control" v-model="form.messages_per_domain">
                            <small>If you fill this value, the mailer will pick a domain with currently lowest number of
                                messages sent from this mailer account to send messages, after reaching this above limit
                                it will
                                pick a domain again with the same criteria.</small>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="col-6">
                <div class="form-group row">
                    <label for="picker1" class="col-sm-4 control-label">
                        First campaign start at (EST):
                    </label>
                    <div class="col-lg-6">
                        <!-- <datetime class="form-control" v-model="form.scheduled_at">
                            </datetime> -->
                        <input type="text" class="form-control" v-model="form.scheduled_at"
                            :placeholder="schedulePlaceholder | estTime" />
                        <small>Use <strong>EST time</strong> (UTC-5)</small>
                    </div>
                </div>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-4">Time interval in minutes</label>
                        <div class="col-lg-6">
                            <input type="number" min="0" class="form-control" v-model="form_common.minutes_interval">
                            <small>An interval between each of the campaigns in minutes.</small>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div class="col-6" v-if="false">
                <div class="form-group row">
                    <label class="col-form-label col-lg-3">Choose campaign tag</label>
                    <div class="col-lg-6">
                        <div class="">
                            <multiselect v-model="form_common.tag" tag-placeholder="" placeholder="Search tag"
                                label="value" track-by="value" :options="campaign_tags || []" :multiple="false">
                            </multiselect>

                        </div>
                    </div>
                </div>

            </div>
            <div class="col-6" v-if="false">
                <div class="form-group row">
                    <label class="col-form-label col-lg-3">Choose contact list tag</label>
                    <div class="col-lg-6">
                        <div class="">
                            <multiselect v-model="form_common.contact_list_tag" tag-placeholder=""
                                placeholder="Search tag" label="value" track-by="value"
                                :options="contact_list_tags || []" :multiple="false">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12" v-if="form.mailer_account === null">
                        <label class="col-form-label col-lg-12">List of domains (one per line)</label>
                        <ace-editor :editor-id="'step1_domains'" @change-content="contentChangedStep1Domains"
                            :content="step1_domains || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="col-form-label col-lg-12">List of contact lists (one per line)</label>
                        <ace-editor :editor-id="'step1_lists'" @change-content="contentChangedStep1Lists"
                            :content="step1_lists || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label class="col-form-label col-lg-12">List of subjects (one per line)</label>
                        <ace-editor :editor-id="'step1_subjects'" @change-content="contentChangedStep1Subjects"
                            :content="step1_subjects || ''" lang="text" theme="monokai"
                            v-bind:style="{ 'width': '100%', height: '300px' }"></ace-editor>
                    </div>
                </div>
            </div>



            <div class="row" v-if="step1Errors">
                <div class="col-lg-12">
                    <div class="alert alert-danger" v-html="step1Errors"></div>
                </div>
            </div>
        </div>
        <div class="row" v-if="step === 1">
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-primary" @click="addCampaign"
                        :disabled="form_common.minutes_interval === 0">Add
                        campaign</button>
                </div>
            </div>
            <div class="row col-12" v-for="campaign, k in campaigns"
                style="border-bottom:1px solid rgba(0,0,0,.2); margin: 10px">
                <div class="col-12">
                    <button class="btn btn-danger" @click="campaigns.splice(k, 1)">Remove</button>
                </div>
                <div class="col-12"
                    v-if="campaigns[k].domain && campaigns[k].domain.campaigns && campaigns[k].domain.campaigns.length"
                    style="margin-top: 10px">
                    <div class="alert alert-danger">This domain was used {{ campaigns[k].domain.campaigns.length }}
                        time(s)
                        before. <span style="text-decoration: underline; cursor: pointer"
                            @click="toggleDetails($event, k)">Click to show details</span>
                        <div v-if="campaigns[k].domain.campaign_details">
                            <ul>
                                <li v-for="c in campaigns[k].domain.campaigns"><strong>campaign</strong>: {{ c.name }},
                                    <strong>created_at</strong>: {{ c.created_at | formatDate }},
                                    <strong>status</strong>:
                                    {{ c.status }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                        <div class="form-group row">
                            <label class="col-form-label col-lg-3">Choose contact list</label>
                            <div class="col-lg-8">
                                <div class="form-check form-check-inline">
                                    <multiselect v-model="campaigns[k].list" tag-placeholder=""
                                        @search-change="contactListFind" :searchable="true" :loading="loadingTypeahead"
                                        placeholder="Search for a contact list" label="name" track-by="_id"
                                        :options="list || []" :multiple="false"></multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-lg-3">Choose sub/domain</label>
                            <div class="col-lg-8">
                                <div class="form-check form-check-inline">
                                    <multiselect v-model="campaigns[k].domain" tag-placeholder=""
                                        @search-change="domainFind" :searchable="true" :loading="loadingTypeahead"
                                        placeholder="Search for a sub/domain" label="name" track-by="name"
                                        :options="domain || []" :multiple="false"></multiselect>
                                </div>
                            </div>
                        </div>


                        <div class="form-group row">
                            <label class="col-form-label col-lg-3">Choose campaign tag</label>
                            <div class="col-lg-8">
                                <div class="form-check form-check-inline">
                                    <multiselect v-model="campaigns[k].tag" tag-placeholder="" placeholder="Search tag"
                                        label="value" track-by="value" :options="campaign_tags || []" :multiple="false">
                                    </multiselect>

                                </div>
                            </div>
                        </div>


                        <div class="form-group row">
                            <label class="col-form-label col-lg-3">Choose contact list tag</label>
                            <div class="col-lg-8">
                                <div class="form-check form-check-inline">
                                    <multiselect v-model="campaigns[k].contact_list_tag" tag-placeholder=""
                                        placeholder="Search tag" label="value" track-by="value"
                                        :options="contact_list_tags || []" :multiple="false"></multiselect>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-form-label col-lg-3">Throttle send (mail per hour)</label>
                            <div class="col-lg-6">
                                <input type="text" class="form-control" v-model="campaigns[k].send_limit">
                                <small>Value "0" means - no throttling</small>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="col-6">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-3">Subject</label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="campaigns[k].subject">
                        </div>
                    </div>
                    <div class="form-group row" :class="{ disabled: form_common.name_template }">
                        <label class="col-form-label col-lg-3">
                            Sender address
                        </label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="campaigns[k].sender_address">
                            <small>(the part before @, ex. <strong>noreply</strong>@domain.com</small>
                            <small>Leave it blank and it will be filled with values from default names in
                                settings</small>
                        </div>
                    </div>
                    <div class="form-group row" :class="{ disabled: form_common.name_template }">
                        <label class="col-form-label col-lg-3">Sender name</label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="campaigns[k].sender_name">
                            <small>Leave it blank and it will be filled with values from default names in
                                settings</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="picker1" class="col-sm-3 control-label">
                            Schedule campaign (EST):
                        </label>
                        <div class="col-lg-8">
                            <!-- <datetime class="form-control" v-model="form.scheduled_at">
                            </datetime> -->
                            <input type="text" class="form-control" v-model="campaigns[k].scheduled_at"
                                :placeholder="schedulePlaceholder | estTime" />
                            <small>Use <strong>EST time</strong> (UTC-5)</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="step === 2">
            <div class="col-6">
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Random sentences (one per line)</label>
                        <div class="col-lg-10">
                            <ace-editor :editor-id="'random_sentences'" @change-content="contentChanged2"
                                :content="form.random_sentences || ''" lang="text" theme="monokai"
                                v-bind:style="{ 'width': '100%', height: '100px' }"></ace-editor>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Random subjects (one per line)</label>
                        <div class="col-lg-10">
                            <ace-editor :editor-id="'random_subjects'" @change-content="contentChanged3"
                                :content="form.random_subjects || ''" lang="text" theme="monokai"
                                v-bind:style="{ 'width': '100%', height: '100px' }"></ace-editor>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <button class="btn btn-primary" style="margin-bottom: 5px"
                                @click="show_help = !show_help">Toggle
                                help</button>
                            <div class="alert alert-primary" v-if="show_help">
                                <strong>Manual:</strong>
                                <p>Use <strong v-html="'[unsubscribe_url]'"></strong> to place an URL to unsubscribe.
                                </p>
                                <p>Use <strong v-html="'{{random_sentence}}'"></strong> to place a random sentence from
                                    above.
                                </p>
                                <p>There are also contact data available:
                                    <strong v-html="'{{template}}'"></strong>,
                                    <strong v-html="'{{domain}}'"></strong>,
                                    <strong v-html="'{{first_name}}'"></strong>,
                                    <strong v-html="'{{last_name}}'"></strong>,
                                    <strong v-html="'{{address}}'"></strong>,
                                    <strong v-html="'{{city}}'"></strong>,
                                    <strong v-html="'{{zip_code}}'"></strong>,
                                    <strong v-html="'{{state}}'"></strong>
                                    <strong v-html="'{{from_name}}'"></strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Select template tags or fill content below</label>
                        <div class="col-lg-10">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.message_templates" tag-placeholder=""
                                    @search-change="templateFind" :searchable="true" :loading="loadingTypeahead"
                                    placeholder="Search for a template TAG" label="_id" track-by="_id"
                                    :options="templateList || []" :multiple="true"></multiselect>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="col-12" v-if="form.message_templates.length === 0">
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <div class="col-lg-6">
                            <ace-editor :editor-id="'query_editor'" @change-content="contentChanged"
                                :content="form.content || ''" lang="html" theme="monokai"
                                v-bind:style="{ 'width': '100%', height: '800px' }"></ace-editor>
                        </div>
                        <div class="col-lg-6 msg-container" style="padding: 0; height: 800px">
                            <div :class="{ 'ifrfull': fullscreen }" style="height: 98%; background: white">
                                <button class="btn btn-primary" @click="fullscreen = !fullscreen">Toggle
                                    fullscreen</button>
                                <iframe id="asd" frameBorder="0"
                                    style="border: 1px solid grey; width:99%; height: 95%; margin: 5px;"></iframe>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="col-12">
            <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                <div class="alert alert-danger" v-if="err">{{ err }}</div>
                <div class="alert alert-success" v-if="success">{{ success }}</div>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" v-if="step > 1" @click="step--">Back</button>
                        <button type="button" class="btn btn-primary" v-if="step < 2 && campaigns.length > 0"
                            @click="step++">Next</button>
                        <button type="button" class="btn btn-primary" v-if="step === 2" @click="save()">Save</button>
                        <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                    </label>
                </div>
            </fieldset>
        </div>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import aceEditor from '../common/Ace.js'
import datetime from 'vuejs-datetimepicker';
import moment from 'moment'

let dbtm

export default {
    components: { modal, aceEditor, datetime },
    props: {
        id: null,
    },
    data() {
        return {
            testEmail: '',
            step: 0,
            show_help: false,
            fullscreen: false,

            form_common: {
                name: null,
                name_template: null,
                minutes_interval: 0,
            },

            campaigns: [],

            form: {
                content: "",
                random_sentences: "",
                random_subjects: "",
                message_templates: [],
                mailer_account: null,
                messages_per_domain: 0,
                tag: null,
                contact_list_tag: null,
            },
            err: null,
            success: null,
            loading: false,

            scheduled_at_date: null,
            scheduled_at_time: null,

            mailer_account: [],
            list: [],
            templateList: [],
            domain: [],
            name_templates: [],

            step1_lists: ``,
            step1_domains: ``,
            step1_subjects: ``,
            verifiedLists: null,
            loadingTypeahead: false,

            campaign_tags: [],
            contact_list_tags: [],

            // Campaign template functionality
            campaign_templates: [],
            selected_template: null
        }
    },
    methods: {
        toggleDetails(_, k) {
            this.campaigns[k].domain.campaign_details = !this.campaigns[k].domain.campaign_details
            this.$forceUpdate()
            console.log(this.campaigns[k].domain.campaign_details)
        },
        domainFind(query) {
            if (query === '') {
                return
            }
            this.domain = this.domain.filter(l => l._keep)

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('typeahead/domain?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.domain = this.domain.concat(this.reformatValidDomains(res.body.data.domain))
                })
            }, 500)
        },
        contactListFind(query) {
            if (query === '') {
                return
            }
            this.list = this.list.filter(l => l._keep)

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('typeahead/contact_list?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.list = res.body.data.list
                })
            }, 500)
        },
        getFirstScheduledAt: function () {
            return moment().utcOffset(-5 * 60)
        },
        addCampaign: function () {
            let date = moment(this.form.scheduled_at, 'DD-MM-YY HH:mm:00');
            if (this.campaigns.length > 0) {
                date = moment(this.campaigns[this.campaigns.length - 1].scheduled_at, 'DD-MM-YY HH:mm:00');
                date = date.add(this.form_common.minutes_interval, 'minutes');
            }

            this.campaigns.push({
                list: null,
                mailer_account: null,
                domain: null,
                subdomain: null,
                send_limit: this.form.send_limit,
                scheduled_at: date.format('DD-MM-YY HH:mm:00'),
                tag: this.form_common.tag,
                contact_list_tag: this.form_common.contact_list_tag,
            })
        },
        formatDatetime: function (datetime) {
            if (datetime === null) {
                return "[null]";
            } else {
                return datetime.format("YYYY-MM-DD HH:mm:ss");
            }
        },
        contentChangedStep1Domains(c) {
            this.step1_domains = c
        },
        contentChangedStep1Lists(c) {
            this.step1_lists = c
        },
        contentChangedStep1Subjects(c) {
            this.step1_subjects = c
        },
        contentChanged2(c) {
            this.form.random_sentences = c
        },
        contentChanged3(c) {
            this.form.random_subjects = c
        },
        contentChanged(c) {
            this.form.content = c
            let iframe = document.getElementById('asd')
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(c);
            iframe.contentWindow.document.close();
        },
        sendTest() {
            this.loading = true

            this.$api.postReq(`campaign/${this.id}/test`, {
                email: this.testEmail,
                content: this.form.content
            }).then(res => {
                this.loading = false
                this.$notify.addSuccess('Mail sent.')
            }).catch(res => {
                this.loading = false
                this.$notify.addError(res.body.error)
            })
        },
        saveAndClose() {
            let that = this
            this.save(null, () => {
                that.$emit('close')
                that.$emit('reload')
            })
        },
        templateFind(query) {
            if (query === '') {
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('template_tags?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    this.templateList = res.body.data
                })
            }, 500)
        },
        reformatValidDomains(_d) {
            let domains = []
            _d.map(d => {
                d.subdomains.map(sd => {
                    if (!d.all_subdomains_validated) {
                        return
                    }
                    domains.push({
                        _id: d._id,
                        subdomain: sd.subdomain,
                        name: (sd.subdomain && sd.subdomain + "." || '') + d.domain,
                        mailer_account: d.mailer_account,
                        campaigns: d.campaigns
                    })
                })
            })

            return domains
        },
        async validate1Step() {
            let f = {
                domains: this.step1Domains,
                contact_lists: this.step1Lists
            }

            this.$api.postReq('verify', f).then(res => {
                this.loading = true
                this.verifiedLists = res.body.result
                this.loading = false

                if (this.verifiedLists.missing_lists.length === 0 && this.verifiedLists.missing_domains.length === 0) {
                    let k = 0
                    this.campaigns = []

                    let domains = this.reformatValidDomains(res.body.result.domains)

                    this.step1Domains.forEach(d => {
                        this.addCampaign()
                        this.campaigns[k].domain = domains.filter(_d => _d.name === d).pop()
                        this.campaigns[k].list = res.body.result.lists.filter(_l => this.step1Lists[k] == _l.name).pop()
                        this.campaigns[k].subject = this.step1Subjects[k]
                        k++
                    })
                    this.step++
                }
            })
        },
        async save(_, cb) {

            let valid = await this.validate()
            if (valid === false) {
                return
            }

            this.loading = true
            let len = this.campaigns.length
            for (var i = 0; i < len; i++) {
                try {
                    let c = JSON.parse(JSON.stringify(this.campaigns[i]))
                    c.name = this.form_common.name + ' #' + (i + 1)
                    c.name_template = this.form_common.name_template

                    c.content = this.form.content
                    c.random_sentences = this.form.random_sentences
                    c.random_subjects = this.form.random_subjects

                    await this._save(c, false)
                    this.$notify.addSuccess(`Campaign ${(i + 1)} saved`)
                } catch (e) {
                    break
                }
            }
            this.loading = false
            this.$emit('reload')
            this.$emit('close')
        },
        async validate(_, cb) {
            this.loading = true
            let len = this.campaigns.length
            for (var i = 0; i < len; i++) {
                let c
                try {
                    c = JSON.parse(JSON.stringify(this.campaigns[i]))
                    c.name = this.form_common.name + ' #' + (i + 1)
                    c.name_template = this.form_common.name_template

                    c.content = this.form.content
                    c.random_sentences = this.form.random_sentences
                    c.random_subjects = this.form.random_subjects

                    await this._save(c, true)
                } catch (e) {
                    console.error(e)
                    this.loading = false
                    this.err = `[${c.name}]: ${this.err}`
                    return false
                }
            }
            this.loading = false

            return true
        },
        _save(campaign, validate) {
            let self = this;
            return new Promise((resolve, reject) => {
                console.log(moment(campaign.scheduled_at + ' -05:00', 'DD-MM-YYYY HH:mm:ss ZZ').toDate())
                console.log(campaign.name_template)
                let f = {
                    name: campaign.name,
                    scheduled_at: moment(campaign.scheduled_at + ' -05:00', 'DD-MM-YYYY HH:mm:ss ZZ').toDate(),
                    list: campaign.list && campaign.list._id,
                    domain: campaign.domain && campaign.domain._id,
                    subdomain: campaign.domain && campaign.domain.subdomain,
                    mailer_account: campaign.domain && campaign.domain.mailer_account && campaign.domain.mailer_account._id,
                    sender_address: campaign.sender_address,
                    sender_name: campaign.sender_name,
                    content: campaign.content,
                    subject: campaign.subject,
                    message_templates: self.form.message_templates.map(t => t._id),

                    send_limit: campaign.send_limit,
                    random_sentences: campaign.random_sentences,
                    random_subjects: campaign.random_subjects,
                    messages_per_domain: self.form.messages_per_domain,

                    tag: campaign.tag && campaign.tag.value,
                    contact_list_tag: campaign.contact_list_tag && campaign.contact_list_tag.value,

                    sender_template: campaign.name_template && campaign.name_template._id,
                }

                if (self.form.mailer_account) {
                    f.mailer_account = self.form.mailer_account._id
                    delete f.domain
                }

                this.$api.postReq('campaign' + (validate && '?skip_saving=1' || ''), f).then(res => {
                    resolve()
                    this.loading = false
                    setTimeout(() => {
                        this.success = null
                    }, 1000)
                }).catch(res => {
                    reject()
                    this.err = res.body.error
                })

            })
        },
        // Campaign template methods
        async loadCampaignTemplates() {
            try {
                const res = await this.$api.getReq('campaign_template', { limit: 99999 })
                this.campaign_templates = res.body.data || []
            } catch (e) {
                console.error('Error loading campaign templates:', e)
            }
        },
        async onTemplateSelected(template) {
            if (!template) return

            this.loading = true
            try {
                // Get full template details
                const templateRes = await this.$api.getReq(`campaign_template/${template._id}`)
                const templateData = templateRes.body.data

                // Get message template content if available
                let messageContent = ''
                if (templateData.message_template && templateData.message_template._id) {
                    const messageRes = await this.$api.getReq(`template/${templateData.message_template._id}`)
                    messageContent = messageRes.body.data.content || ''
                }

                // Populate form fields
                this.populateFromTemplate(templateData, messageContent)

            } catch (e) {
                console.error('Error loading template details:', e)
                this.err = 'Error loading template: ' + (e.body && e.body.error || e.message)
            }
            this.loading = false
        },
        populateFromTemplate(templateData, messageContent) {
            // Set campaign name with current date/time (user can modify)
            const currentDateTime = moment().format('Do MMM YYYY')
            this.form_common.name = `${templateData.name} - ${currentDateTime}`

            // Set time interval
            this.form_common.minutes_interval = templateData.time_interval || 0

            // Set sender template if available
            if (templateData.sender_template) {
                const senderTemplate = this.name_templates.find(nt => nt._id === templateData.sender_template._id)
                if (senderTemplate) {
                    this.form_common.name_template = senderTemplate
                }
            }

            // Populate text fields
            this.step1_domains = templateData.domains_text || ''
            this.step1_lists = templateData.contact_lists_text || ''
            this.step1_subjects = templateData.subjects_text || ''

            // Set message content
            this.form.content = messageContent

            // Set start date with template start_hours
            const startDate = moment().utcOffset(-5 * 60) // EST timezone
            if (templateData.start_hours !== undefined) {
                // Parse the new time format (e.g., "5:20", "5.20", or legacy number format)
                let hours = 0
                let minutes = 0

                if (typeof templateData.start_hours === 'string') {
                    // Handle string formats like "5:20" or "5.20"
                    const timeStr = templateData.start_hours.toString()
                    if (timeStr.includes(':')) {
                        const parts = timeStr.split(':')
                        hours = parseInt(parts[0]) || 0
                        minutes = parseInt(parts[1]) || 0
                    } else if (timeStr.includes('.')) {
                        const parts = timeStr.split('.')
                        hours = parseInt(parts[0]) || 0
                        minutes = parseInt(parts[1]) || 0
                    } else {
                        // Handle string numbers like "5"
                        hours = parseInt(timeStr) || 0
                        minutes = 0
                    }
                } else {
                    // Handle legacy numeric format
                    hours = parseInt(templateData.start_hours) || 0
                    minutes = 0
                }

                startDate.hour(hours).minute(minutes).second(0)
                // If the time has passed today, set it for tomorrow
                if (startDate.isBefore(moment().utcOffset(-5 * 60))) {
                    startDate.add(1, 'day')
                }
            }
            this.form.scheduled_at = this.$options.filters.estTime(startDate)

            // Update iframe preview if content is available
            if (messageContent) {
                this.$nextTick(() => {
                    let iframe = document.getElementById('asd')
                    if (iframe) {
                        iframe.contentWindow.document.open()
                        iframe.contentWindow.document.write(messageContent)
                        iframe.contentWindow.document.close()
                    }
                })
            }
        },
        clearTemplate() {
            this.selected_template = null
            // Reset form fields to defaults
            this.form_common.name = null
            this.form_common.name_template = null
            this.form_common.minutes_interval = 0
            this.step1_domains = ''
            this.step1_lists = ''
            this.step1_subjects = ''
            this.form.content = ''
            this.form.scheduled_at = this.$options.filters.estTime(this.getFirstScheduledAt().add(15, 'minutes'))

            // Clear iframe
            this.$nextTick(() => {
                let iframe = document.getElementById('asd')
                if (iframe) {
                    iframe.contentWindow.document.open()
                    iframe.contentWindow.document.write('')
                    iframe.contentWindow.document.close()
                }
            })
        },
    },
    watch: {
        'form.mailer_account': function (v) {
            if (v === null) {
                return
            }

            this.step1_domains = ''
        },
        'step': function (v) {
            if (v === 2) {
                if (this.form.content) {
                    let self = this
                    setTimeout(function () {
                        self.contentChanged(self.form.content)
                    }, 100)
                }
            }
        }
    },
    computed: {
        schedulePlaceholder() {
            return moment()
        },
        canTestEmail() {

            if (this.id === null) {
                return false
            }

            if (this.testEmail.indexOf('@') <= 0) {
                return false
            }

            if (this.form.message_templates.length === 0) {
                if (!this.form.mailer_account || !this.form.domain) {
                    return false
                }
            } else {
                return true
            }

            return true
        },
        canNext() {
            switch (this.step) {
                case 0:
                    return this.form_common.name && this.form_common.minutes_interval > 0 && this.step1ErrorsForm === ''
                case 1:
                    return this.step < 2 && this.campaigns.length > 0
            }
        },
        step1Domains() {
            return this.step1_domains.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1Lists() {
            return this.step1_lists.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1Subjects() {
            return this.step1_subjects.split("\n").map(s => s.trim()).filter(s => s)
        },
        step1ErrorsForm() {
            let dc = this.step1Domains.length
            let lc = this.step1Lists.length
            let sc = this.step1Subjects.length

            if (dc > 0 && (dc !== lc || dc !== sc || lc !== sc)) {
                return 'Fill the same number of rows in every column'
            }
            return ''
        },
        step1Errors() {
            if (this.step1ErrorsForm) {
                return this.step1ErrorsForm
            }

            if (this.verifiedLists && (this.verifiedLists.missing_domains || this.verifiedLists.missing_lists)) {
                let msg = ''
                if (this.verifiedLists.missing_domains.length) {
                    msg += `Missing domains or not validated: ${this.verifiedLists.missing_domains.map(d => {
                        return d + ` (line #${this.step1Domains.indexOf(d) + 1})`
                    }).join(', ')} <br/>`
                }
                if (this.verifiedLists.missing_lists.length) {
                    msg += `Missing contact lists: ${this.verifiedLists.missing_lists.map(d => {
                        return d + `(#${this.step1Lists.indexOf(d) + 1})`
                    }).join(', ')} <br/>`
                }
                return msg
            }

            return ''
        }
    },
    mounted() {
        this.loading = 1

        if (document.location.href.indexOf('localhost') >= 0) {
            this.step1_lists = `foo
            foo`
            this.step1_domains = `a1.baz.com
            a1.baz.com`
            this.step1_subjects = `test
            test2`

            this.form_common.name = 'ttesst' + new Date()
            this.form_common.minutes_interval = 10
        }

        this.form.scheduled_at = this.$options.filters.estTime(this.getFirstScheduledAt().add(15, 'minutes'))

        this.$api.getReq('campaign_create').then(res => {
            this.mailer_account = res.body.data.mailer_account
            this.name_templates = res.body.data.name_templates.map(n => {
                n.name = n._id
                return n
            })
            this.form.send_limit = res.body.data.default_throttle || 0
            this.campaign_tags = res.body.data.campaign_tags
            this.contact_list_tags = res.body.data.contact_list_tags
            this.loading--

        })

        // Load campaign templates
        this.loadCampaignTemplates()

    }
}
</script>
<style>
.modal-full {
    height: 95% !important;
    top: 0;
    width: 99% !important;
}

.ifrfull {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 1000000 !important;
}

div.disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #CCC;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/MultipleCampaignCreator.vue